import { gql } from '@apollo/client'

import { USER_FRAGMENT } from '../fragments'

export const RESTORE_USER = gql`
  mutation RestoreUser($id: ID!) {
    restoreUser(id: $id) {
      ...User
    }
  }
  ${USER_FRAGMENT}
`
